import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { BALANCE_SHEET_BASE_PATH } from '../../../../../../../../../features/accounting/balance-sheet/balance-sheet-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/balance-sheet/_balance-sheet')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'balance-sheet',
        label: 'Accounting',
        to: BALANCE_SHEET_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
